const FACEBOOK_IN_APP_BROWSER_PATTERN = /\b(FBAN|FBAV|FB_IAB|FBIOS)\b/i
const INSTAGRAM_IN_APP_BROWSER_PATTERN = /\bInstagram\b/i

export function isFacebookInAppBrowserUserAgent(userAgent: string): boolean {
    return Boolean(userAgent) && FACEBOOK_IN_APP_BROWSER_PATTERN.test(userAgent)
}

export function isMetaInAppBrowserUserAgent(userAgent: string): boolean {
    if (!userAgent) return false
    return isFacebookInAppBrowserUserAgent(userAgent) || INSTAGRAM_IN_APP_BROWSER_PATTERN.test(userAgent)
}
